import React, { useState, useEffect } from "react";
import "./index.css";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";
import { toast } from "react-toastify";
import Loader from "../../Loader";
// import COLORS from "../../Themes/Colours";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


const AddNewUser = ({ isOpen, onClose, fetchUserData, editUser = null, isEditMode = false }) => {
  const [formValues, setFormValues] = useState({
    user_id: "",
    name: "",
    gender: "",
    email: "",
    mobile: "",
    organization: "Upl Snipe",
    Date_of_birth: "",
    address: "",
    state_name: "",
    city_name: "",
    department: "Admin",
    role: "",
    activation: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [user_id, setUser_id] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [Date_of_birth, setDate_Of_Birth] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [selectedRole, setRoleName] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [activation, setActivation] = useState(false);
  const { COLORS } = useThemeMode();
  

  const aiDishaApi = createInstance("DISHA");

  const roleNames = {
    Admin: "Admin"
  };

  // Initialize form with edit data when in edit mode
  useEffect(() => {
    if (isEditMode && editUser) {
      setUser_id(editUser.user_id || "");
      setName(editUser.name || "");
      setEmail(editUser.email || "");
      setMobile(editUser.mobile || "");
      setDate_Of_Birth(editUser.Date_of_birth || "");
      setGender(editUser.gender || "");
      setAddress(editUser.address || "");
      setRoleName(editUser.role || "");
      setSelectedState(editUser.state_name || "");
      setSelectedCity(editUser.city_name || "");
      setActivation(editUser.activation || false);
      
      setFormValues(prev => ({
        ...prev,
        user_id: editUser.user_id || "",
        name: editUser.name || "",
        gender: editUser.gender || "",
        email: editUser.email || "",
        mobile: editUser.mobile || "",
        Date_of_birth: editUser.Date_of_birth || "",
        address: editUser.address || "",
        state_name: editUser.state_name || "",
        city_name: editUser.city_name || "",
        role: editUser.role || "",
        activation: editUser.activation || false,
        sequence_value: editUser.user_id || "",
      }));

      // Fetch cities for the selected state in edit mode
      if (editUser.state_name) {
        fetchAllCities(editUser.state_name);
      }
    }
  }, [isEditMode, editUser]);

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!name.trim()) {
        console.error("Full name cannot be empty");
        Toast.error("Full name cannot be empty");
        return;
      }

      if (!gender.trim()) {
        console.error("Gender cannot be empty");
        Toast.error("Gender cannot be empty");
        return;
      }

      if (!email.trim()) {
        console.error("Email cannot be empty");
        Toast.error("Email cannot be empty");
        return;
      }

      if (!mobile.trim()) {
        console.error("Mobile number cannot be empty");
        Toast.error("Mobile number cannot be empty");
        return;
      }

      if (!Date_of_birth.trim()) {
        console.error("Date of birth cannot be empty");
        Toast.error("Date of birth cannot be empty");
        return;
      }

      if (!address.trim()) {
        console.error("Address cannot be empty");
        Toast.error("Address cannot be empty");
        return;
      }

      if (!selectedState || !selectedState.trim()) {
        console.error("State name cannot be empty");
        Toast.error("State name cannot be empty");
        return;
      }

      if (!selectedCity || !selectedCity.trim()) {
        console.error("City name cannot be empty");
        Toast.error("City name cannot be empty");
        return;
      }

      if (!selectedRole || !selectedRole.trim()) {
        console.error("Role cannot be empty");
        Toast.error("Role cannot be empty");
        return;
      }
      
      console.log(`${isEditMode ? 'Updating' : 'Adding'} user data:`, name, email, mobile, Date_of_birth, address, user_id);
      setIsSubmitting(true);
      
      let response;
      
      if (isEditMode) {
        // Update existing user
        response = await aiDishaApi.put(
          `/update-subsequent-admin`,
          {
            name: name,
            email: email,
            mobile: parseInt(mobile, 10), // Convert mobile to number as per your API requirement
            Date_of_birth: Date_of_birth,
            address: address,
            activation: activation,
            organization: formValues.organization,
          },
          {
            params: {
              user_id: user_id,
              gender: gender,
              state_name: selectedState,
              city_name: selectedCity,
              role: selectedRole,
            },
          }
        );
      } else {
        // Create new user
        response = await aiDishaApi.post(
          "/create-subsequent-admin",
          {
            name: name,
            email: email,
            mobile: mobile,
            Date_of_birth: Date_of_birth,
            address: address,
          },
          {
            params: {
              gender: gender,
              state_name: selectedState,
              city_name: selectedCity,
              status: "InActive",
              role: selectedRole,
            },
          }
        );
      }

      if (response.status === 200) {
        console.log(`${isEditMode ? 'Updated' : 'Created'} admin:`, response);
        toast.success(`User ${isEditMode ? 'updated' : 'added'} successfully`, { autoClose: 3000 });
        clearForm();
        onClose();
        fetchUserData();
      }
    } catch (error) {
      console.error("Error:", error.response?.data?.detail);
      const errorMessage = error.response?.data?.detail?.[0]?.msg || "Something went wrong";
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const clearForm = () => {
    setName("");
    setEmail("");
    setMobile("");
    setDate_Of_Birth("");
    setAddress("");
    setGender("");
    setSelectedState("");
    setSelectedCity("");
    setRoleName("");
    setUser_id("");
    setActivation(false);
    setFormValues({
      user_id: "",
      name: "",
      gender: "",
      email: "",
      mobile: "",
      organization: "Upl Snipe",
      Date_of_birth: "",
      address: "",
      state_name: "",
      city_name: "",
      department: "Admin",
      role: "",
      activation: false,
    });
  };

  const handleStateDropdown = (event) => {
    const stateValue = event.target.value;
    setSelectedState(stateValue);
    fetchAllCities(stateValue);
    // Clear city selection when state changes
    setSelectedCity("");
  };

  const handleCityDropdown = (event) => {
    setSelectedCity(event.target.value);
  };

  const handleDropdownChange1 = (event) => {
    const Role_name = event.target.value;
    setRoleName(Role_name);
  };

  useEffect(() => {
    fetchStates();
    if (!isEditMode) {
      fetchSequenceValue();
    }
  }, [isEditMode]);

  const fetchStates = async () => {
    try {
      const response = await aiDishaApi.get("/get-all-states");
      console.log("States API Response:", response.data);
      
      // Ensure states is always an array
      const statesData = response.data;
      if (Array.isArray(statesData)) {
        setStates(statesData);
      } else {
        // If response.data is an object, try to extract states array
        const statesArray = statesData?.states || statesData?.data || [];
        setStates(Array.isArray(statesArray) ? statesArray : []);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setStates([]);
    }
  };

  const fetchAllCities = async (state) => {
    try {
      const response = await aiDishaApi.get(`/filter_cities?state_name=${state}`);
      console.log("Cities API Response:", response.data);
      
      // Ensure cities is always an array
      const citiesData = response.data;
      if (Array.isArray(citiesData)) {
        setCities(citiesData);
      } else {
        // If response.data is an object, try to extract cities array
        const citiesArray = citiesData?.cities || citiesData?.data || [];
        setCities(Array.isArray(citiesArray) ? citiesArray : []);
      }
    } catch (error) {
      console.error("Error fetching all cities in the given state" + error);
      setCities([]);
    }
  };

  const fetchSequenceValue = async () => {
    try {
      const response = await aiDishaApi.get("/get-all-users");
      const sequenceValue = parseInt(response?.data?.All_users?.[0]?.sequence_value, 10) || 0;

      console.log("Sequence Value from API:", response.data.sequence_value);
      setFormValues((prev) => ({
        ...prev,
        sequence_value: `UID000${sequenceValue + 1}`,
      }));
    } catch (error) {
      console.error("Error fetching sequence value:", error);
    }
  };

  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      style={{
        display: isOpen ? "block" : "none",
      }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered w-50">
        <div className="modal-content" style={{ background: COLORS.primary, color:COLORS.text }}>
          <div className="modal-header border-0">
            <h5 className="modal-title" style={{ color: COLORS.text, fontFamily: "Poppins" }}>
              {isEditMode ? "Edit User" : "Add New User"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <form onSubmit={handleFormSubmit}>
            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4">
                <label
                  className="aa"
                  htmlFor="userId"
                  style={{
                    label: "Disabled",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  User ID
                </label>
                <input
                  type="text"
                  name="userId"
                  className="form-control form-control-sm"
                  value={isEditMode ? user_id : formValues.sequence_value}
                  aria-label="User ID"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none"
                  }}
                  readOnly
                />
              </div>

              <div className="col-sm-8">
                <label
                  htmlFor="fullName"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Full Name
                </label>
                <input
                  type="text"
                  name="Enter your fullName"
                  className="form-control form-control-sm"
                  placeholder="Enter Name"
                  aria-label="Full Name"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                  }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required={true}
                  disabled={false}
                />
              </div>
            </div>

            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4">
                <label
                  htmlFor="gender"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Gender
                </label>
                <select
                  name="gender"
                  className="form-select form-select-sm"
                  aria-label="Small select example"
                  style={{
                   background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                  }}
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <option value="" disabled>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div className="col-sm-4">
                <label
                  htmlFor="email"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Email ID
                </label>
                <input
                  type="email"
                  name="email"
                  className="form-control form-control-sm"
                  placeholder="Enter Email ID"
                  aria-label="Email ID"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required={true}
                />
              </div>
              <div className="col-sm-4">
                <label
                  htmlFor="mobile"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Mobile
                </label>
                <input
                  type="text"
                  name="mobile"
                  className="form-control form-control-sm"
                  placeholder="Enter Mobile Number"
                  aria-label="Mobile"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                  }}
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                />
              </div>

              <div className="col-sm-4">
                <label
                  className="aa"
                  htmlFor="organization"
                  style={{
                    label: "Disabled",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Organization
                </label>
                <input
                  type="text"
                  name="organization"
                  className="form-control form-control-sm"
                  value={formValues.organization}
                  aria-label="Organization"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none"
                  }}
                  readOnly
                />
              </div>

              <div className="col-sm-4">
                <label
                  htmlFor="specificSizeInputName"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Date of Birth
                </label>
                <input
                  type="text"
                  name="dob"
                  className="form-control form-control-sm"
                  placeholder="YYYY-MM-DD"
                  aria-label="Date of Birth"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                  }}
                  value={Date_of_birth}
                  onChange={(e) => setDate_Of_Birth(e.target.value)}
                />
              </div>

              <div className="col-sm-4">
                <label
                  className="visually-shown"
                  htmlFor="specificSizeInputName"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Address
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Enter your address"
                  aria-label="Address"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                    "& input::placeholder": {
                       color: `${COLORS.text} !important`, // 👈 placeholder color
                       opacity: 10, // important (MUI reduces opacity by default)
                     },
                  }}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
            </div>

            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4">
                <label
                  htmlFor="specificSizeInputName"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  State
                </label>
                <select
                  name="state"
                  className="form-select form-select-sm"
                  aria-label="Small select example"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                  }}
                  value={selectedState}
                  onChange={handleStateDropdown}
                >
                  <option value="" disabled>
                    Select State
                  </option>
                  {Array.isArray(states) && states.map((state, index) => {
                    // Handle different API response formats
                    const stateValue = typeof state === 'string' ? state : 
                                     state?.state_name || state?.name || state?.value || '';
                    const stateDisplay = typeof state === 'string' ? state : 
                                        state?.state_name || state?.name || state?.display || stateValue;
                    const stateKey = typeof state === 'string' ? `state-${index}` : 
                                    state?._id || state?.id || state?.state_id || `state-${index}`;
                    
                    return (
                      <option key={stateKey} value={stateValue}>
                        {stateDisplay}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="col-sm-4">
                <label
                  htmlFor="specificSizeInputName"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  City
                </label>
                <select
                  name="city"
                  className="form-select form-select-sm"
                  aria-label="Small select example"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                  }}
                  value={selectedCity}
                  onChange={handleCityDropdown}
                  disabled={!selectedState}
                >
                  <option value="" disabled>
                    Select City
                  </option>
                  {Array.isArray(cities) && cities.map((city, index) => {
                    // Handle different API response formats
                    const cityValue = typeof city === 'string' ? city : 
                                     city?.city_name || city?.name || city?.value || '';
                    const cityDisplay = typeof city === 'string' ? city : 
                                       city?.city_name || city?.name || city?.display || cityValue;
                    const cityKey = typeof city === 'string' ? `city-${index}` : 
                                   city?._id || city?.id || city?.city_id || `city-${index}`;
                    
                    return (
                      <option key={cityKey} value={cityValue}>
                        {cityDisplay}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="col-sm-4">
                <label
                  className="aa"
                  htmlFor="department"
                  style={{
                    label: "Disabled",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Department
                </label>
                <input
                  type="text"
                  name="department"
                  className="form-control form-control-sm"
                  aria-label="department"
                  style={{
                    background: COLORS.background,
                    color:COLORS.text,
                    border: "none"
                  }}
                  value={formValues.department}
                  readOnly
                />
              </div>
            </div>

            <div className="row" style={{ margin: "0% 2%" }}>
              <div className="col-sm-4">
                <label
                  htmlFor="specificSizeInputName"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    color: COLORS.text,
                  }}
                >
                  Role
                </label>
                <select
                  name="Role"
                  className="form-select form-select-sm"
                  aria-label="Small select example"
                  style={{
                    background: COLORS.background,
                    color: COLORS.text,
                    border: "none",
                  }}
                  value={selectedRole}
                  onChange={handleDropdownChange1}
                >
                  <option value="" disabled>Select Role</option>
                  {Object.keys(roleNames).map((Role_name) => (
                    <option key={Role_name} value={Role_name}>
                      {roleNames[Role_name]}
                    </option>
                  ))}
                </select>
              </div>

              {isEditMode && (
                <div className="col-sm-4">
                  <label
                    htmlFor="activation"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      color: COLORS.text,
                    }}
                  >
                    Activation Status
                  </label>
                  <select
                    name="activation"
                    className="form-select form-select-sm"
                    aria-label="Activation Status"
                    style={{
                      background: COLORS.background,
                      color: COLORS.text,
                      border: "none",
                    }}
                    value={activation.toString()}
                    onChange={(e) => setActivation(e.target.value === 'true')}
                  >
                    <option value="false">Inactive</option>
                    <option value="true">Active</option>
                  </select>
                </div>
              )}
            </div>

            <div className="modal-footer d-flex flex-row justify-content-right border-0">
              <button
                type="button"
                className="btn btn-sm rounded-2 fw-medium"
                onClick={clearForm}
                style={{
                  color: COLORS.button,
                  "&:hover":{
                    color: COLORS.hover_btn
                  },
                  width: "120px",
                  border: "1px solid #033538",
                }}
              >
                Clear
              </button>
              <button
                type="submit"
                className="btn btn-sm rounded-2 fw-medium"
                style={{
                  background: COLORS.button,
                  "&:hover":{
                    background: COLORS.hover_btn
                  },
                  color: COLORS.background,
                  width: "120px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <div className="spinner-border spinner-border-sm text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  isEditMode ? "Update" : "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddNewUser;